<template>
  <page-layout class="company-admin-page-layout">
    <router-view></router-view>
  </page-layout>
</template>

<script>
import PageLayout from './pageLayout.vue'

export default {
  components: {
    PageLayout
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.company-admin-page-layout {
  height: 100%;
  font-size: 14px;
  line-height: 20px;
}
</style>
